import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dumbbell, Layers, Users2 } from "lucide-react";
import ExercisesTab from "@/components/ExercisesTab";
import TemplatesTab from "@/components/TemplatesTab";
import ClientPlansTab from "@/components/ClientPlansTab";

const TABS = [
  { key: "exercises", label: "Esercizi", icon: <Dumbbell size={14} /> },
  { key: "templates", label: "Template", icon: <Layers size={14} /> },
  { key: "assigned", label: "Schede clienti", icon: <Users2 size={14} /> },
];

export default function TrainerPlansPage({ clients }) {
  const [tab, setTab] = useState("exercises");
  const [exercises, setExercises] = useState([]);

  const loadEx = async () => {
    try { const { data } = await api.get("/exercises"); setExercises(data); } catch {}
  };
  useEffect(() => { loadEx(); }, [tab]);

  return (
    <div>
      <div className="flex sm:inline-flex w-full sm:w-auto border border-white/10 mb-6">
        {TABS.map(t => (
          <button key={t.key} data-testid={`plans-tab-${t.key}`}
            onClick={() => setTab(t.key)}
            className={`flex-1 sm:flex-none justify-center px-2 sm:px-4 py-2 font-heading uppercase tracking-wider sm:tracking-widest text-[10px] sm:text-xs transition-colors flex items-center gap-1 sm:gap-2 border-l first:border-l-0 border-white/10 ${tab === t.key ? "bg-[#A855F7] text-white" : "text-white/60 hover:text-white"}`}>
            {t.icon} {t.label}
          </button>
        ))}
      </div>
      {tab === "exercises" && <ExercisesTab />}
      {tab === "templates" && <TemplatesTab exercises={exercises} />}
      {tab === "assigned" && <ClientPlansTab clients={clients} exercises={exercises} />}
    </div>
  );
}
